export const AVA_INTRO_TEXT = "Hi, I'm Ava, your AI interviewer. Thanks for joining today — I'll ask you a few questions, so take your time with each answer.";

// Ava's on-screen avatar: a still portrait with a voice indicator while she speaks.
export function AvaTile({ speaking }) {
  return (
    <div className="absolute inset-0" data-testid="ava-tile" data-mode={speaking ? "talk" : "idle"}>
      <img src="/ava/ava.jpg?v=3" alt="Ava, AI interviewer" className="absolute inset-0 w-full h-full object-cover" data-testid="ava-photo" />
      {speaking && (
        <span className="absolute top-2 right-2 z-10 flex items-end gap-0.5 h-4 px-1.5 py-1 rounded bg-black/50 backdrop-blur" data-testid="ava-voice-bars" aria-hidden>
          {[0, 1, 2, 3].map((i) => <span key={i} className="w-0.5 rounded-full bg-indigo-300 animate-pulse" style={{ height: `${[60, 100, 75, 45][i]}%`, animationDelay: `${i * 120}ms` }} />)}
        </span>
      )}
      <span className="absolute bottom-1.5 left-1.5 z-10 inline-flex items-center gap-1.5 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-black/60 text-white backdrop-blur whitespace-nowrap" data-testid="ava-label">
        <span className={`w-1.5 h-1.5 rounded-full ${speaking ? "bg-indigo-300 animate-pulse" : "bg-emerald-400"}`} /><span>Ava<span className="hidden sm:inline"> · AI interviewer</span></span>
      </span>
    </div>
  );
}
